var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pt-4"},[_c('metrics-table-for-portfolio',{attrs:{"portfolio":_vm.portfolio,"portfolio-id":_vm.portfolio.id,"show-individual-metrics":_setup.showIndividualMetrics},on:{"update:showIndividualMetrics":(val) => (_setup.showIndividualMetrics = val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }